var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader, Message } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import * as SCMP from "../../components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingCurrentEvents component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
let RacingCurrentEvents = class RacingCurrentEvents extends React.Component {
    constructor(props) {
        super(props);
        this.dict = this.props.dict;
        this.state = {
            dataProvider: this.props.dataProvider,
        };
    }
    /* istanbul ignore next */
    renderRows(rows) {
        return rows.map(x => {
            return (React.createElement(CMP.Row, { key: x.id },
                React.createElement(CMP.Place, { label: x.leagueName, hasLiveStream: x.hasLiveStream }),
                React.createElement(CMP.Events, null, this.renderEvents(x.events))));
        });
    }
    /* istanbul ignore next */
    renderEvents(events) {
        return events.map(x => this.renderEvent(x));
    }
    /* istanbul ignore next */
    renderEvent(event) {
        return (React.createElement(SCMP.Event, { key: event.id, url: event.url, label: event.title, status: this.state.dataProvider.racingStore.getEventStatus(event.raceProgress), handler: event.handler ? event.handler : () => { } }));
    }
    /* istanbul ignore next */
    renderLoader() {
        return (React.createElement("div", { className: "rj-racing-current-races__loader" },
            React.createElement(Loader, null)));
    }
    renderMessageOrLoader() {
        if (!this.state.dataProvider.racingStore.isTodayEventsPresent) {
            return (React.createElement(Message, { text: this.dict.NoMarketsAvailable }));
        }
        else {
            return this.renderLoader();
        }
    }
    /* istanbul ignore next */
    render() {
        let l = this.state.dataProvider.branchViewLeagueEvents.length;
        return (React.createElement("div", { className: "rj-racing-current-races" },
            (!l || l === 0) && this.renderMessageOrLoader(),
            (l > 0) && this.renderRows(this.state.dataProvider.branchViewLeagueEvents)));
    }
};
RacingCurrentEvents = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RacingCurrentEvents);
export { RacingCurrentEvents };
//# sourceMappingURL=RacingCurrentEvents.js.map